import { render } from "./warehouseManagement.vue?vue&type=template&id=9de5c9fa&scoped=true"
import script from "./warehouseManagement.vue?vue&type=script&lang=js"
export * from "./warehouseManagement.vue?vue&type=script&lang=js"

import "./warehouseManagement.vue?vue&type=style&index=0&id=9de5c9fa&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de5c9fa"]])

export default __exports__